/**
 * Created by ori on 07/08/16.
 */
'use strict';
import React, {Component} from 'react'
import {observer} from 'mobx-react';

@observer(['state','actions'])
export default class VerifyEmail extends Component {
    componentWillMount() {
        this.props.actions.verifyUser(this.props.routeParams.random);
    }

    render() {
        const verifyUI = this.props.state.currentUser;
        let message = '';
        if (verifyUI.error) {
            message = 'Wrong verification code';
        } else if (this.props.state.isLogged && !verifyUI.verificationError) {
            message = 'Successful verification!';
        }
        return <div>{message}</div>;
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/VerifyEmail.js